import { createContext, type ReactNode, useContext } from 'react';
import { createHaulerCentralClient, type HaulerCentralApiClient } from './HaulerCentralClient';

interface HaulerCentralContextType {
  client: HaulerCentralApiClient;
}

const HaulerCentralContext = createContext<HaulerCentralContextType | undefined>(undefined);

interface HaulerCentralProviderProps {
  children: ReactNode;
  baseURL?: string;
}

/**
 * HaulerCentral Provider Component
 */
export function HaulerCentralProvider({ children, baseURL }: HaulerCentralProviderProps) {
  const client = createHaulerCentralClient({ baseURL });

  return (
    <HaulerCentralContext.Provider value={{ client }}>{children}</HaulerCentralContext.Provider>
  );
}

/**
 * Hook to use HaulerCentral client
 */
export function useHaulerCentral(): HaulerCentralApiClient {
  const context = useContext(HaulerCentralContext);
  if (!context) {
    throw new Error('useHaulerCentral must be used within HaulerCentralProvider');
  }
  return context.client;
}
